interface PercentilRingProps {
  percentual: number;
  label: string;
  sublabel?: string;
  cor: string;
  tamanho?: number;
}

export const PercentilRing = ({ 
  percentual, 
  label, 
  sublabel, 
  cor, 
  tamanho = 120 
}: PercentilRingProps) => {
  const percentualSeguro = Math.min(100, Math.max(0, percentual));
  
  const raio = (tamanho - 20) / 2;

  const circunferencia = 2 * Math.PI * raio;
  const offset = circunferencia - (percentualSeguro / 100) * circunferencia;
  
  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: tamanho, height: tamanho }}>
        <svg
          width={tamanho}
          height={tamanho}
          className="transform -rotate-90"
          viewBox={`0 0 ${tamanho} ${tamanho}`}
        >
          {/* Círculo de fundo */}
          <circle
            cx={tamanho / 2}
            cy={tamanho / 2}
            r={raio}
            stroke="#e5e7eb"
            strokeWidth="8"
            fill="transparent"
            className="opacity-30"
          />
          
          {/* Círculo de progresso */}
          <circle
            cx={tamanho / 2}
            cy={tamanho / 2}
            r={raio}
            stroke={cor}
            strokeWidth="8"
            fill="transparent"
            strokeDasharray={circunferencia}
            strokeDashoffset={offset}
            strokeLinecap="round"
            className="transition-all duration-1000 ease-out"
            style={{
              strokeDashoffset: offset,
            }}
          />
        </svg>
        
        {/* Texto central */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-2xl font-bold text-gray-800">
            {percentualSeguro}%
          </span>
        </div>
      </div>
      
      {/* Labels */}
      <div className="mt-3 text-center">
        <p className="text-sm font-medium text-gray-700">
          {label}
        </p>
        {sublabel && (
          <p className="text-xs text-gray-500 mt-1">
            {sublabel}
          </p>
        )}
      </div>
    </div>
  );
};